import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar, Navigation } from 'swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function O() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('offgrid');
    const { locale } = useRouter();
    const lists: any = [
        {
            title: t('secO_list1_title'),
            desc: t('secO_list1_desc'),
        },
        {
            title: t('secO_list2_title'),
            desc: t('secO_list2_desc'),
        },
        {
            title: t('secO_list3_title'),
            desc: t('secO_list3_desc'),
        },
    ];

    return (
        <div id="off-grid-O" className={`off-grid-O off-grid-box ${css['off-grid-O']}`}>
            <div className="ef-box">
                <div className="text-info">
                    <h2 className="title">{t('secO_title')}</h2>
                </div>
                <Swiper
                    className="swiper-box"
                    effect="fade"
                    modules={[Scrollbar, Navigation]}
                    navigation={true}
                    spaceBetween={0}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 32,
                        snapOnRelease: true,
                    }}
                >
                    {lists?.map((card: any, k: number) => (
                        <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                            <div className="swiper-item-text">
                                <p className="card-desc text">{card?.desc}</p>
                                <p className="card-title">{card?.title}</p>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}
